import React, { useState, useEffect } from 'react';
import { Coins, Plus, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CreditBalance = ({ showBuyButton = true, size = 'normal' }) => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadBalance();
    
    // Listen for credit update events
    const handleCreditUpdate = () => {
      loadBalance();
    };
    
    window.addEventListener('creditBalanceUpdated', handleCreditUpdate);
    
    // Refresh balance every 30 seconds when component is visible
    const interval = setInterval(() => {
      if (document.visibilityState === 'visible') {
        loadBalance();
      }
    }, 30000);
    
    return () => {
      window.removeEventListener('creditBalanceUpdated', handleCreditUpdate);
      clearInterval(interval);
    };
  }, []);

  const loadBalance = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await axios.get(`${API}/credits/balance`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      setBalance(response.data);
    } catch (error) {
      console.error('Error loading credit balance:', error);
    } finally {
      setLoading(false);
    }
  };

  const goToCredits = () => {
    navigate('/credits');
  };

  if (loading) {
    return (
      <div className={`flex items-center space-x-2 ${size === 'small' ? 'text-sm' : ''}`}>
        <RefreshCw className={`animate-spin ${size === 'small' ? 'w-4 h-4' : 'w-5 h-5'}`} />
        <span>Loading...</span>
      </div>
    );
  }

  const balanceAmount = balance?.total_balance || 0;
  const isLowBalance = balanceAmount < 5; // Warn when balance is less than $5

  return (
    <div className={`flex items-center space-x-2 ${size === 'small' ? 'text-sm' : ''}`}>
      <div className="flex items-center space-x-2">
        <div className={`bg-yellow-500 rounded-full p-1 ${size === 'small' ? 'p-1' : 'p-2'}`}>
          <Coins className={`text-white ${size === 'small' ? 'w-3 h-3' : 'w-4 h-4'}`} />
        </div>
        <div>
          <div className={`font-semibold ${isLowBalance ? 'text-red-600' : 'text-green-600'}`}>
            ${balanceAmount.toFixed(2)}
          </div>
          {size !== 'small' && (
            <div className="text-xs text-gray-500">Credits</div>
          )}
        </div>
      </div>

      {showBuyButton && (
        <button
          onClick={goToCredits}
          className={`bg-rose-600 hover:bg-rose-700 text-white rounded-lg transition-colors flex items-center space-x-1 ${
            size === 'small' ? 'px-2 py-1 text-xs' : 'px-3 py-2 text-sm'
          }`}
        >
          <Plus className={size === 'small' ? 'w-3 h-3' : 'w-4 h-4'} />
          <span>Buy</span>
        </button>
      )}
    </div>
  );
};

export default CreditBalance;